export var PasswordStrength;
(function (PasswordStrength) {
    PasswordStrength[PasswordStrength["none"] = 0] = "none";
    PasswordStrength[PasswordStrength["error"] = 1] = "error";
    PasswordStrength[PasswordStrength["weak"] = 2] = "weak";
    PasswordStrength[PasswordStrength["good"] = 3] = "good";
    PasswordStrength[PasswordStrength["veryGood"] = 4] = "veryGood";
})(PasswordStrength || (PasswordStrength = {}));
//# sourceMappingURL=PasswordStrength.js.map